import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiListItemAvatar(theme: Theme): Components['MuiListItemAvatar'] {
  return {
    styleOverrides: {
      root: {
        minWidth: 'auto',
        marginRight: theme.spacing(2),
      },
    },
  };
}
